import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnfyingGlass = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M756 191H845V294H911V191H1000V133H911V20H845V133H756ZM82 397V328C82 209 177 118 316 118C455 118 551 209 551 328V397C551 520 471 614 318 614C166 614 82 520 82 397ZM756 497H1000V431H756ZM0 362C0 563 137 688 316 688C390 688 457 666 511 627L862 954L920 897L567 571C609 517 633 446 633 362C633 175 495 44 316 44C137 44 0 175 0 362Z" })
});
export default SvgMagnfyingGlass;
